import { createSlice } from "@reduxjs/toolkit";
import { foldersTemplateActions } from "./folders.action";


interface FoldersTemplateState {
    loading: boolean;
    success: any;
    error: any;
    templateFolders: any;
    childFolders: any;
}

const initialState: FoldersTemplateState = {    
    loading: false,
    success: null,
    error: null,
    templateFolders: null,
    childFolders: null,
}

const foldersTemplateSlice = createSlice({
    name: 'foldersTemplate',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

        // --------------------- cases of get template folders api data -------------------------
        .addCase(foldersTemplateActions.getTemplateFoldersAction.pending, (state) => {
            state.loading = true;
            state.templateFolders = null;
        })
        .addCase(foldersTemplateActions.getTemplateFoldersAction.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action?.payload;
            state.templateFolders = action?.payload?.data?.data;
        })
        .addCase(foldersTemplateActions.getTemplateFoldersAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.templateFolders = null;
        })

        // --------------------- cases of get child folders api data -------------------------
        .addCase(foldersTemplateActions.getChildFoldersAction.pending, (state) => {
            state.loading = true;
        })
        .addCase(foldersTemplateActions.getChildFoldersAction.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action?.payload;
            state.templateFolders = action?.payload?.data?.data;
        })
        .addCase(foldersTemplateActions.getChildFoldersAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        // --------------------- cases of create new folder api data -------------------------
        .addCase(foldersTemplateActions.createNewFolderAction.pending, (state) => {
            state.loading = true;
        })
        .addCase(foldersTemplateActions.createNewFolderAction.fulfilled, (state, action) => {
            state.loading = false;
            state.templateFolders = action?.payload?.data?.data;
        })
        .addCase(foldersTemplateActions.createNewFolderAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        // --------------------- cases of delete folder api data -------------------------
        .addCase(foldersTemplateActions.deleteFolderAction.pending, (state) => {
            state.loading = true;
        })
        .addCase(foldersTemplateActions.deleteFolderAction.fulfilled, (state, action) => {
            state.loading = false;
            state.templateFolders = action?.payload?.data?.data;
        })
        .addCase(foldersTemplateActions.deleteFolderAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }) 
        
        // --------------------- cases of rename folder api data -------------------------
        .addCase(foldersTemplateActions.renameFolderAction.pending, (state) => {
            state.loading = true;
        })
        .addCase(foldersTemplateActions.renameFolderAction.fulfilled, (state, action) => {
            state.loading = false;
            state.templateFolders = action?.payload?.data?.data;
        })
        .addCase(foldersTemplateActions.renameFolderAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

    }
})

export default foldersTemplateSlice.reducer;